import React from 'react';

export default function ThankYou() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 to-accent/5 flex items-center justify-center px-6">
      <div className="max-w-2xl text-center">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>

        <h1 className="text-4xl font-bold text-primary mb-4">Thank You!</h1>

        <p className="text-xl text-gray-700 mb-8">We've received your request for a tax strategy assessment.</p>

        <p className="text-gray-600 mb-8">
          One of our tax strategists will review your information and reach out within 24 hours to schedule your complimentary consultation.
        </p>

        <div className="bg-white p-6 rounded-lg shadow-sm">
          <h2 className="font-semibold text-lg mb-3">What Happens Next?</h2>
          <ol className="text-left space-y-2 text-gray-600">
            <li className="flex items-start">
              <span className="font-semibold text-primary mr-2">1.</span>
              <span>We'll review your submission and prepare a preliminary analysis</span>
            </li>
            <li className="flex items-start">
              <span className="font-semibold text-primary mr-2">2.</span>
              <span>Schedule a 30-minute consultation with a tax strategist</span>
            </li>
            <li className="flex items-start">
              <span className="font-semibold text-primary mr-2">3.</span>
              <span>Receive a customized tax strategy proposal</span>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
}
